<script setup lang="ts">
const props = defineProps<{
  src: string;
  alt: string;
  rounded?: boolean;
  fetchPriority?: string;
  transparent?: boolean;
  contain?: boolean;
  noLazy?: boolean;
  noTransition?: boolean;
  placeholder?: boolean;
  placeholderIcon?: string;
  noPlaceholderIcon?: boolean;
  restrictWidth?: number;
}>();

const useCFImage = import.meta.env.VITE_ENABLE_CF_IMAGE_OPTIMIZATION === "1";
</script>

<template>
  <CFImage
    v-if="useCFImage"
    v-bind="props"
  />
  <LegacyImage
    v-else
    v-bind="props"
  />
</template>

<style scoped lang="postcss"></style>
